import { LS_KEY } from "constants.js";

// Access token store in local storage
export function useAccessToken() {
    const ls = window.localStorage.getItem(LS_KEY);
    const accessToken = ls && JSON.parse(ls);

    return accessToken;
}
